import * as React from 'react';
import {CSSProperties} from 'react';
import * as Tgcc from '../tgccGlobal';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {CloseX} from './CloseX';



const img: React.CSSProperties = {
    maxWidth:'400px',
    maxHeight:'500px',
    position:'relative',
    left:'50%',
    marginLeft:'-200px',
    top:'8%'

}
const XStyle: React.CSSProperties = {
    fontSize:'40px',
    color:'rgb(97, 96, 96)',
    float:'right',
    cursor:'pointer',
    padding:'0px 5px'
}
const container: React.CSSProperties = {
    position:'fixed',
    height:'600px',
    width:'500px',
    zIndex:100,
    backgroundColor:'white',
    left:'50%',
    marginLeft:'-250px',
    top:'18%',
    borderRadius:'10px'
}

class Props extends Tgcc.BaseProps {
    src: string;
}

export class _EnLargeUpload extends React.Component<Props, any> {
    cancel = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null});
    }
    render(){
        return (
                <div style={container} className="enlargeDiv">
                    <div onClick={this.cancel} style={XStyle} className="corpXEnlargeImg">&times;</div>
                    <img style={img} src={this.props.src} className="enlargeUpload"/>                
                </div>

        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};
export var EnLargeUpload = connect(mapStateToProps)(_EnLargeUpload);


